<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-7">
                        <div class="font-weight-bold body-1">
                            Detalles de recibo
                        </div>
                    </v-col>
                </v-row> 
                <v-row justify="center">
                    <v-col cols="12" md="7" >
                    <Separator title="Datos generales"/>
                    <details-item :detailsItems="items"></details-item>

                    <Separator title="Datos de entrega" v-if="deliveryItems.length > 0"/>
                    <details-item :detailsItems="receivedItems"></details-item>
                    <div class="receipt-details-image-container">
                        <v-img :src="receivedsignedImage" alt="" height="300" contain></v-img>
                    </div>
                    <details-item :detailsItems="deliveryItems"></details-item>
                    <div class="receipt-details-image-container">
                        <v-img :src="deliSignedImage" alt="" height="300" contain></v-img>
                    </div>
                    </v-col>
                    
                </v-row>
                

            </div>
            <v-row justify="center" align="end">
				<v-col cols="12" md="7" class="d-flex justify-end">
                    
					<primary-button :props="cancelBtnData"></primary-button>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import DetailsItem from '../../components/DetailsItem.vue';
import Separator from '../../components/Separator.vue';
import Utils from "../../helpers/Utils";
export default {
    components: {
        DetailsItem,
        Separator
    },
	data(){
		return {
            id: this.$route.params.id,
            loading: false,
           
            items: [
               
                
            ],
            receivedItems:[],
            deliveryItems:[],
            receivedsignedImage:'',
            deliSignedImage:'',
            
           
            cancelBtnData: {
                text: "Regresar",
                icon: "",
                to: "Receipts",	
                click: () => {}
            },
            
         
          
		}
    },
    mounted(){
        this.index();
    },
	methods: {
		validate () {
			return this.$refs.form.validate()
		},
        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.receipt.get(this.$store.state.business, this.id)
			.then((response) => {
                console.log(response);
                // this.items.forEach((y) => {
                //     y.valor = response.data[y.index]
                // });
                this.items= [
                    { concepto: 'Folio', index: 'folio', valor: response.data.folio },
                    { concepto: 'Proyecto', index: 'folio', valor: response.data?.project?.name??"" },
                    { concepto: 'Emitido por', index: 'folio', valor: response.data.emitted_by??"" },
                    { concepto: 'Entregado por', index: 'folio', valor: response.data.delivered_by??"" },
                    { concepto: 'Recibido por', index: 'folio', valor: response.data.received_by??"" },
                    { concepto: 'Fecha de emisión', index: 'folio', valor:Utils.globalDateFormat(response.data.date??"") },
                    { concepto: 'Monto', index: 'folio', valor: Utils.currencyFormat(response.data.amount??"") },
                    { concepto: 'Concepto', index: 'folio', valor: response.data?.concept?.name??"" },
                    { concepto: 'Observaciones', index: 'folio', valor: response.data.reference??"" },
                   
                   
                ];
                if(response.data.signatures != null && response.data.signatures.length > 0){
                    const receivedData = response.data.signatures.find((x) => x.type == 'RECEIVED')
                    if(receivedData != undefined){
                        this.receivedItems.push(
                            { concepto: 'Fecha y hora de entrega', index: 'folio', valor: `${Utils.globalDateFormat(receivedData.date.split(" ")[0])} ${receivedData.date.split(" ")[1]}` },
                            { concepto: 'Firma de quien recibe', hideDivider:true, index: 'folio', valor: `` },
                        );
                        this.receivedsignedImage = receivedData.signature_url;

                    }
                    const delivData = response.data.signatures.find((x) => x.type == 'DELIVERED')
                    this.deliveryItems.push(
                        // { concepto: 'Fecha y hora de entrega', index: 'folio', valor: `${Utils.globalDateFormat(response.data.signature.date.split(" ")[0])} ${response.data.signature.date.split(" ")[1]}` },
                        { concepto: 'Firma de quien entrega', hideDivider:true, index: 'folio', valor: `` },
                    );
                    this.deliSignedImage = delivData.signature_url;
                }

			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
		},
       
    },
}
</script>

<style>
    .v-skeleton-loader__text{
        margin-bottom: 0px;
    }
    .pre{
        white-space: pre-line;
    }

    .receipt-details-image-container{
        background-color: rgb(232, 231, 231);
    }
</style> 